import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectPhone = (state: IApplicationState): string => {
  const newbuilding = selectNewbuilding(state);

  const { phone, builderInfo, isDealRequestSubstitutionPhone } = newbuilding;

  const builderPhone = builderInfo && builderInfo.phone;
  const resultPhone = isDealRequestSubstitutionPhone ? builderPhone : builderPhone || phone;

  return resultPhone || '';
};
